<iss-typeahead-select
  [formControl]="control.control"
  [items$]="items$"
  [loading$]="loading$"
  [placeholder]="placeholder || 'label.service-type' | translate"
  [readonly]="readonly"
  [loading]="loading"
  [stringify]="stringify"
  [content]="content"
  [identity]="identity"
  [matcher]="matcher"
  [clearable]="clearable"
  [multi]="multi"
  [withAll]="multi"
>
  <ng-content/>
</iss-typeahead-select>
